import { useContext } from "react";

import { CollectionPageContext } from "./CollectionPageContext";

export const useCollectionPageContext = () => {
  const context = useContext(CollectionPageContext);

  return context;
};
